
import { twicifyAirtable } from '~/helpers/twicpics'

export default {
  name: 'Accueil',
  asyncData: async ({ $db }) => {
    const rawCategories = await $db.fetch('categories')
    const categories = rawCategories.map((c) => ({
      ...c,
      imageThumbnail: twicifyAirtable(c.imageThumbnail)
    }))
    return {
      recentProducts: await $db.fetch('recentProducts'),
      categories
    }
  }
}
